export default "__VITE_ASSET__KunLyWN___"